import React from "react";
import PolicyPage from "./PolicyPage";
import { STORE } from "../config/store";

const sections = [
  {
    title: "Physical orders and available destinations",
    paragraphs: [`This policy covers tangible goods ordered from ${STORE.brand}. The country and region selector shown during checkout is the operative destination list for that order attempt. A destination must be selectable and a complete deliverable address must be entered before Pay Now.`],
  },
  {
    title: "Delivery charge and total",
    paragraphs: [`Each order receives a single delivery fee of ${STORE.currency} ${STORE.shippingFee.toFixed(2)}. Before the hosted-payment transfer, checkout separately presents merchandise, delivery and their combined payable total.`],
  },
  {
    title: "Address review and correction",
    paragraphs: ["The customer must review the recipient, email, destination, street, city, postal code and any required regional field. A correction request should be emailed immediately with the order reference. A change can be applied only while fulfilment records and parcel preparation can still be updated."],
  },
  {
    title: "Order-specific progress",
    paragraphs: ["Any dispatch or delivery estimate supplied for an accepted order is tied to that order rather than a site-wide guarantee. Destination processing, customs examination, severe weather, transport interruption and an incorrect address can affect progress. Keep order correspondence until the parcel and contents have been checked."],
  },
  {
    title: "Cross-border delivery",
    paragraphs: ["For a destination outside the operating region, border assessment and destination restrictions can apply. Import charges and clearance responsibilities are explained separately because they are not part of the merchandise subtotal or fixed delivery charge shown by this checkout."],
    links: [["International Orders & Customs", "/international-orders"]],
  },
  {
    title: "Delivery problem workflow",
    paragraphs: ["If an order-specific estimate passes without delivery, or the parcel arrives damaged or with incorrect contents, preserve the correspondence, item, label and packing and start a case through customer service. The evidence needed for each type of issue and the available outcomes are set out in the package policy."],
    links: [["Lost, Delayed & Damaged Packages", "/package-issues"]],
  },
];

export default function Delivery() {
  return <PolicyPage title="Shipping & Delivery Policy" intro="Destination selection, the fixed charge, address responsibilities and order-specific delivery records." sections={sections} related={[["Packaging & Sustainability", "/packaging"], ["Returns, Refunds & Exchanges", "/returns"]]} />;
}
